var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 130,
    viewBox: "0 0 152 130",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.751 129.885c39.288 0 77.543-29.113 77.543-68.401S102.5.885 63.213.885C23.925.885.037 9.901.037 49.19c0 39.287 34.427 80.696 73.714 80.696z",
    fill: "#EEF4F9",
    opacity: 0.374
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.628 79.5h-.013a3.997 3.997 0 0 1-2.851-1.207l-9.158-9.389a4 4 0 0 1 5.726-5.586l6.313 6.472L85.78 55.487a4 4 0 1 1 5.691 5.623L74.473 78.312a4 4 0 0 1-2.845 1.188z",
    fill: "#008448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5 107C51.617 107 33 88.383 33 65.5S51.617 24 74.5 24 116 42.617 116 65.5 97.383 107 74.5 107zm0-75C56.028 32 41 47.028 41 65.5S56.028 99 74.5 99 108 83.972 108 65.5 92.972 32 74.5 32z",
    fill: "#E6E9ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.8fd4974864ff2854e017c57ecfeb35be.svg";
export { ForwardRef as ReactComponent };